import type {RouteRecordRaw} from "vue-router";

const kb: RouteRecordRaw[] = [];

export default kb;
